import { formatLicensePlate } from 'noddi-util';
import type { CarGroup } from './notificationGroupTypes';

export const CarIdentity = ({ car }: { car: CarGroup }) => (
  <div className='min-w-0'>
    <p className='truncate font-medium'>
      {car.make} {car.model}
    </p>
    <p className='truncate text-sm text-muted-foreground'>{formatLicensePlate(car.licensePlate.number)}</p>
  </div>
);
